import { render, staticRenderFns } from "./costMaterialConfig.vue?vue&type=template&id=0358790a&scoped=true"
import script from "./costMaterialConfig.vue?vue&type=script&lang=js"
export * from "./costMaterialConfig.vue?vue&type=script&lang=js"
import style1 from "./costMaterialConfig.vue?vue&type=style&index=1&id=0358790a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358790a",
  null
  
)

export default component.exports